import de from '../translations/de.json';
import en from '../translations/en.json';
import enUS from '../translations/en-us.json';
import fr from '../translations/fr.json';
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    de,
    fr,
    en,
    'en-GB': en,
    'en-US': enUS,
};
